import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { AuthService, AccountsService, Store } from '../../shared/services';
import { Router } from '@angular/router';
import { Account, TopLevelWithoutHeaderComponent } from '../../shared/models';

@Component({
  styles: [require('./choose-account.component.scss')],
  template: require('./choose-account.component.pug')
})
export class ChooseAccountComponent extends TopLevelWithoutHeaderComponent implements OnInit, AfterViewInit, OnDestroy {

  accounts: Account[] = [];
  imageUrl = '/img/accounts_icon3.jpg';
  multipleAccountsRegistered: boolean;
  hasUserAuthorized: boolean;

  constructor(
      private _authSvc: AuthService,
      private _router: Router,
      private _accService: AccountsService,
      public store: Store
      ) {
          super(store);
          this.hasUserAuthorized = this._authSvc.isAuthorized();
    }

  ngOnInit() {
        this.accounts = this._accService.getAccounts();
        this.multipleAccountsRegistered = this.accounts.length > 1;
  }

  ngAfterViewInit() {
    if (this.accounts.length < 1) {
      this._redirectToAddAccount();
    }
  }

  ngOnDestroy() {
     this.componentDestroy();
  }

  login(account: Account) {
      if (account.access_token) {
         this._authSvc.login(account);
         this._router.navigate(['/dashboard']);
      } else {
        this._router.navigate(['accounts/login', account.accountName]);
      }
  }

  addAccountClicked() {
      this._redirectToAddAccount();
  }

  remove(e: MouseEvent, accountToRemove: string) {
      e.preventDefault();
      this._router.navigate(['accounts/delete-account', accountToRemove]);
  }

  goToDashboard() {
      if (this.hasUserAuthorized) {
          this._authSvc.setBearer();
          this._router.navigate(['/dashboard']);
     }
  }

  private _redirectToAddAccount() {
      this._router.navigate(['accounts/add-account']);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounts/choose-account/choose-account.component.ts